import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  VerifyEmailInput,
  VerifyEmailResponse,
  verifyEmailResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIVerifyEmail = (
  options?: UseMutationOptions<
    VerifyEmailResponse,
    ErrorResponse,
    VerifyEmailInput
  >
) =>
  useMutation({
    mutationFn: (data) =>
      post(API_ENDPOINTS.VERIFY_EMAIL, data, verifyEmailResponseSchema),
    throwOnError: false,
    ...options,
  })
